"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timestamp = void 0;
var Timestamp_1 = require("./Timestamp");
Object.defineProperty(exports, "Timestamp", { enumerable: true, get: function () { return Timestamp_1.Timestamp; } });
